import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';

import AppState from 'js/stores/AppState';
import {url} from 'js/services/Network';

import AppContent from 'js/components/AppContent';
import Backdrop from 'js/components/core/Backdrop';
import Constraint from 'js/components/Constraint';
import ErrorDisplay from 'js/components/common/ErrorDisplay';
import DeliveryProgress from './DeliveryProgress';
import DeliveryProgressV2 from "./DeliveryProgressV2";
import Notice from './Notice';
import {formatCurrency} from 'js/services/Format';
import {Link} from '@reach/router';
import ConstraintUnique from "js/components/pages/StatusPage/ItemStatusPage/BuyerReferral/ConstraintUnique";
import ProductDisplayUnique from "js/components/pages/StatusPage/ItemStatusPage/BuyerReferral/ProductDisplayUnique";
import {Button} from "reactstrap";
import Modal from "js/components/core/Modal";
import EditItem from "./EditItem";
import HowItWorksDisplay from "./HowItWorksDisplay";
import OrderReceivedModal from "./OrderReceivedModal";
import PaymentMethodForm from "js/components/pages/StatusPage/PaymentMethodForm";
import OverallStatus from "./OverallStatus";
import HowItWorks from "./HowItWorksDisplay";
import ItemDisplay from "./ItemDisplay";
import ReturnItemLink from "./ReturnItemLink";
import {buttonHeight} from "js/components/common/Button";
import CopyItem from "js/components/core/CopyItem";
import OfferList from "./OfferList"
import ShippingInstructions from "js/stores/types/ShippingInstructions";
import PaymentInfo from "./PaymentInfo";
import Pusher from 'pusher-js';
import BankAccountNotice from "./BankAccountNotice";
import {action, observable} from "mobx";
import analytics from "js/services/Analytics";
import {animated, config, Spring} from "react-spring";
import {endAnimation, primaryColor, startAnimation} from "js/config/style";
import Container from "js/components/pages/StatusPage/ShippingInstructions/Container";
import Row from "js/components/pages/StatusPage/ShippingInstructions/Row";
import Number from "js/components/pages/StatusPage/ShippingInstructions/Number";
import userCountry from "js/services/UserCountry";
import Title from "js/components/pages/StatusPage/ShippingInstructions/Title";
import Instruction from "js/components/pages/StatusPage/ShippingInstructions/Instruction";
import EstimatedPickup from "js/components/pages/StatusPage/ShippingInstructions/EstimatedPickup";
import Places from "js/components/pages/StatusPage/ShippingInstructions/DropoffLocations/Places";
import Place from "js/components/pages/StatusPage/ShippingInstructions/DropoffLocations/Place";
import NameAndAddress from "js/components/pages/StatusPage/ShippingInstructions/DropoffLocations/NameAndAddress";
import DetailsLink from "js/components/pages/StatusPage/ShippingInstructions/DropoffLocations/DetailsLink";
import ModalContents from "js/components/pages/StatusPage/ShippingInstructions/DropoffLocations/ModalContents";
import HoursOfOperation from "js/components/pages/StatusPage/ShippingInstructions/DropoffLocations/HoursOfOperation";
import EmbeddedMap from "js/components/pages/StatusPage/ShippingInstructions/DropoffLocations/EmbeddedMap";

@inject('page')
@observer
export default class ItemStatusPage extends Component {
  @observable locationIndex = null;
  @observable modalIsVisible = false;

  @action showModal = locationIndex => {
    this.locationIndex = locationIndex;
    this.modalIsVisible = true;
  };

  @action closeModal = () => (this.modalIsVisible = false);

  @action onPrintLabelButtonClick = (link) => {

    const page = this.props.page;

    window.open(link, '_blank');

    analytics.track('Purchase Accepted', {
      'Shipping Option': page.order_shipping,
      'Item Price': page.price,
      'Item Name': page.title,
      'Item Size': '',
      'Payment Link':  url('checkout-page', { alias: page.alias }),
      'Event Initiated by': 'buyer'
    });
  };
  constructor(props) {
    super(props);
    this.state = {
      tooltipOpen: false,
      clicked: false,
      clickedToo: false,
      modalOrderReceived: false,
      confirmDelivery: false,
    };
    this.toggle = this.toggle.bind(this);
    let MIX_PUSHER_APP_KEY = "e2f3f0f405d74c3ea3b1";

    //troubleshooting
    // if (process.env.APP_ENV !== 'production') {
    //   console.log("MIX_PUSHER_HOST: ", process.env.PUSHER_HOST)
    //   console.log("MIX_PUSHER_PORT: ", process.env.PUSHER_PORT)
    //   console.log("window.location.hostname: ", window.location.hostname)
    //   console.log("Environment: ", process.env.APP_ENV !== 'production' ? 'Dev': 'Production')
    //   console.log("Env value: ", process.env.APP_ENV)
    // }


    this.pusher = new Pusher(MIX_PUSHER_APP_KEY, {
      wsHost: process.env.MIX_PUSHER_HOST ||  window.location.hostname,
      wsPort: process.env.MIX_PUSHER_PORT || 6001,
      wssPort: process.env.MIX_PUSHER_PORT || 6001,
      forceTLS: true, // Use strings to represent boolean in .env
      enabledTransports: ['ws','wss'],
      disableStats: false,
      cluster: 'eu',
      // debug: true
    });
  }


  componentDidMount() {

    if (process.env.MIX_PUSHER_APP_ENV !== 'production'){
      Pusher.logToConsole = true;
    }


    let channel = this.pusher.subscribe(`order.${this.props.page.alias}`);

    // channel.bind('pusher:subscription_succeeded', function(members) {
    //   console.log('successfully subscribed!  ', members);
    // });

    const page = this.props.page;
    channel.bind('order-status-event', function (data) {
      console.log("Event status: ",data, page)
      if (page?.order_status === 'delivered_to_buyer'){
        setTimeout(() => {
          window.location.reload();
        }, 60000);
      }else{
        window.location.reload();
      }
    });

    // channel.bind("App\\Events\\NewMessage", function(data) {
    //   console.log("messages: ", data);
    // });

    AppState.setNav(
      AppState.previousPage === 'UserDashboardPage'
        ? {
          mode: 'back',
          text: 'Dashboard',
          url: url('user-dashboard-page'),
        }
        : this.props.page.is_seller
          ? {
            mode: 'back',
            text: 'My items',
            url: url('my-items'),
          }
          : {mode: 'normal'},
    );
  }

  toggle() {
    const { modalOrderReceived } = this.state;
    this.setState({
      modalOrderReceived: !modalOrderReceived
    });
  }

  refresh = () => {
    window.location.reload();
  }

  copyAccountNumber = () => {
    navigator.clipboard.writeText(this.props.page.virtual_account.account_number);
    this.setState({clicked: true});

    if (this.timerId) {
      clearTimeout(this.timerId);
    }

    setTimeout(() => {
      this.setState({clicked: false});
    }, 5000);
  };

  copyItem = () => {
    navigator.clipboard.writeText(this.props.page.virtual_account.amount);
    this.setState({clickedToo: true});

    if (this.timerId) {
      clearTimeout(this.timerId);
    }

    setTimeout(() => {
      this.setState({clickedToo: false});
    }, 5000);
  }

  verifyPayment = () => {
    this.refresh();
    // this.props.page.showHowItWorks();
  }

  openOrderReceivedModal = () => {
    console.log("clicked")
    this.setState({modalOrderReceived: true})
  }

  truncate = (str) => {
    return str.length > 21 ? str.substring(0, 18) + "..." : str;
  }

  // getPayAmount = () => {
  //   if (!page.shipping_service) return "[...calculating]";
  //
  //   let bonus = 0;
  //   if (page.address?.country === 'NG' && page.bonus_available >= 500)
  //     bonus = 500
  //   else if (page.address?.country === 'US' && page.bonus_available >= 5)
  //     bonus = 5;
  //
  //   return `${formatCurrency(page.item.price + (page.happy_hour_status === 1 ? 100 : page.shipping_service?.price)
  //     - (page.item.price >= page.discount_data_minimum_checkout_value && (page.discount_usages < page.discount_max_usage) ? page.discount_data_value:0)
  //     - bonus,
  //     page.address?.country)}`;
  // }

  render() {
    const page = this.props.page;
    const altOffset = '0';
    const { modalOrderReceived } = this.state;
    const regex = /(<([^>]+)>)/gi;
    console.log("Page: ", page);
    return (
      <>
        <AppContent className={page.my_relation === 'buyer' ? "tw-bg-white" : ""} padded>
          {page.has_order && page.my_relation === 'buyer' ? (
            <>
              <div className="pod-container tw-mt-8 tw-pr-5 tw-pl-5 ">
                <div className="tw-mt-12 tw-mb-8 tw-flex tw-items-center tw-justify-between">
                  {page.virtual_account?.status !== 'paid' ? (
                    <>
                      <Link className="tw-pb-[2px] tw-hidden md:tw-block tw-text-black tw-text-sm"
                            to={`/seller/${page.seller}`}>
                        <img
                          src="/images/icons/icon-left.svg"
                          alt="back"
                          width="18" height="18"
                        />&nbsp;&nbsp;&nbsp;&nbsp;
                        <span className="tw-h-[18px] tw-text-sm tw-pt-[2px]">
                  Shop {page.seller ? page.seller : 'Someone\'s'} store home &nbsp;&nbsp;&nbsp;>> Cart &nbsp;&nbsp;&nbsp;>> Checkout &nbsp;&nbsp;&nbsp;>>&nbsp;
                          {page.has_order ? (
                            {
                              offer_requested_by_buyer: <span
                                style={{color: '#6D60F6', cursor: 'pointer'}}>Offer pending</span>,
                              no_response_from_seller: <span
                                style={{color: '#6D60F6', cursor: 'pointer'}}>Offer expired</span>,
                              accepted_by_seller: page.is_buyer ? (
                                <span style={{color: '#6D60F6', cursor: 'pointer'}}>Accepted, preparing to ship</span>
                              ) : (
                                <span style={{color: '#6D60F6', cursor: 'pointer'}}>Ready to ship</span>
                              ),
                              accepted_by_seller_exception_by_shipper: <span style={{color: '#6D60F6', cursor: 'pointer'}}>Item is pending</span>,
                              shipped_by_seller: <span style={{color: '#6D60F6', cursor: 'pointer'}}>Item shipped</span>,
                              delivered_to_buyer: <span style={{color: '#6D60F6', cursor: 'pointer'}}>Item delivered</span>,
                              not_accepted_by_seller: <span
                                style={{color: '#6D60F6', cursor: 'pointer'}}>Offer declined</span>,
                              not_accepted_by_buyer: <span
                                style={{color: '#6D60F6', cursor: 'pointer'}}>Offer declined</span>,
                              failed_to_secure_buyer_funds: page.is_buyer ? (
                                <span style={{color: '#6D60F6', cursor: 'pointer'}}>Update needed</span>
                              ) : (
                                <span style={{color: '#6D60F6', cursor: 'pointer'}}>Buyer update needed</span>
                              ),
                              failed_to_secure_buyer_funds_insufficient: page.is_buyer ? (
                                <span style={{color: '#6D60F6', cursor: 'pointer'}}>Update needed</span>
                              ) : (
                                <span style={{color: '#6D60F6', cursor: 'pointer'}}>Buyer update needed</span>
                              ),
                              buyer_updated_card_after_failure: <span style={{color: '#6D60F6', cursor: 'pointer'}}>Offer pending</span>,
                              shipping_rate_changed: <span
                                style={{color: '#6D60F6', cursor: 'pointer'}}>Offer failed</span>,
                              could_not_be_shipped: <span style={{color: '#6D60F6', cursor: 'pointer'}}>Not shipped</span>,
                              delivery_exception: <span
                                style={{color: '#6D60F6', cursor: 'pointer'}}>Delivery exception</span>,
                              not_shipped_by_seller: <span style={{color: '#6D60F6', cursor: 'pointer'}}>Not shipped</span>,
                              return_not_shipped_by_buyer: <span style={{color: '#6D60F6', cursor: 'pointer'}}>Return not shipped</span>,
                              order_completed: <span
                                style={{color: '#6D60F6', cursor: 'pointer'}}>Transaction completed</span>,
                              order_completed_with_error: <span style={{color: '#6D60F6', cursor: 'pointer'}}>Transaction error</span>,
                              order_return_requested: <span
                                style={{color: '#6D60F6', cursor: 'pointer'}}>Return initiated</span>,
                              order_return_shipped: <span
                                style={{color: '#6D60F6', cursor: 'pointer'}}>Return shipped</span>,
                              order_return_delivered: <span
                                style={{color: '#6D60F6', cursor: 'pointer'}}>Return delivered</span>,
                              order_flagged_as_fraud: <span
                                style={{color: '#6D60F6', cursor: 'pointer'}}>Offer failed</span>,
                              order_return_completed: <span
                                style={{color: '#6D60F6', cursor: 'pointer'}}>Return completed</span>,
                            }[page.order_status] || (
                              <span style={{color: '#6D60F6', cursor: 'pointer'}}>Unknown item status error, please contact us. (E501)</span>
                            )
                          ) : page.is_buyer ? (
                            <span style={{color: '#6D60F6', cursor: 'pointer'}}>Offer pending</span>
                          ) : page.has_offers ? (
                            <span style={{color: '#6D60F6', cursor: 'pointer'}}>Offer pending</span>
                          ) : (
                            <span style={{color: '#6D60F6', cursor: 'pointer'}}>Waiting for a buyer</span>
                          )}
                  </span>
                      </Link>
                    </>
                  ) : (
                    <>
                      <Link to={'/'} className="tw-hidden md:tw-block">
                        <img
                          src="/images/icons/smart-home.png"
                          alt="back"
                          width="16" height="17"
                        />&nbsp;&nbsp;&nbsp;&nbsp;
                        <span className="tw-h-[18px] tw-text-sm tw-pt-[2px]" style={{color: '#6D60F6', cursor: 'pointer'}}>Go to dashboard</span>
                      </Link>
                    </>
                  )}

                  <Link to={'/'} className="md:tw-hidden">
                    <img
                      src="/images/icons/smart-home.png"
                      alt="back"
                      width="16" height="17"
                    />&nbsp;&nbsp;&nbsp;&nbsp;
                    <span className="tw-h-[18px] tw-text-sm tw-pt-[2px]" style={{color: '#6D60F6', cursor: 'pointer'}}>Go to dashboard</span>
                  </Link>
                  {/*<button*/}
                  {/*  className="tw-bg-secondary tw-rounded-lg tw-border tw-border-white tw-py-2 tw-px-2 tw-text-white tw-flex-end md:tw-hidden"*/}
                  {/*  onClick={(cta) => buttonCTA(cta, '/create-link')}>*/}
                  {/*  Become a seller &nbsp;*/}
                  {/*  <img*/}
                  {/*    src="/images/icons/right.svg"*/}
                  {/*    alt="shop"*/}
                  {/*    className="size-24px"*/}
                  {/*  />*/}

                  {/*</button>*/}
                </div>
                {page.order_status === 'offer_requested_by_buyer' ? (
                  <>
                    <div>
                      <ConstraintUnique size={'508px'}>
                        <div className="tw-pt-7" style={{border: 0}}>
                    <span>
                      <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Offer pending</p>
                      <p style={{lineHeight: '21px', fontWeight: 400, fontSize: '14px'}}>Your purchase offer is pending. You will be notified as soon as the seller accepts</p>
                    </span>
                          <hr className="tw-mt-7 tw-mb-5" style={{borderTop: '3px solid #bbb'}}/>
                          <div style={{paddingLeft: '0', alignContent: 'center'}}>
                            <ProductDisplayUnique image={page.primary_image} title={page.title} price={page.price}/>
                          </div>
                          <hr className="tw-mt-6 tw-mb-5" style={{borderTop: '3px solid #bbb'}}/>
                        </div>
                        <div className="tw-mt-7 tw-mb-7">
                          <div className="d-flex flex-md-row flex-md-row justify-content-between tw-mt-2 tw-mb-2">
                            <span className="float-start font-weight-lighter"
                                  style={{lineHeight: '20px', fontSize: '16px'}}>Order ID:</span>
                            <span className="float-end font-weight-lighter"
                                  style={{lineHeight: '20px', fontSize: '16px',fontWeight:500}}>{page.order_uid}</span>
                          </div>
                          <div className="d-flex flex-md-row flex-md-row justify-content-between tw-mt-2 tw-mb-2">
                            <span className="float-start font-weight-lighter"
                                  style={{lineHeight: '20px', fontSize: '16px'}}>Seller:</span>
                            <span className="float-end font-weight-lighter"
                                  style={{lineHeight: '20px', fontSize: '16px',fontWeight:500}}>@{this.truncate(page.seller)}</span>
                          </div>
                          <div className="d-flex flex-md-row flex-md-row justify-content-between tw-mt-2 tw-mb-2">
                            <span className="float-start font-weight-lighter"
                                  style={{lineHeight: '20px', fontSize: '16px'}}>Shipping:</span>
                            <span className="float-end font-weight-lighter"
                                  style={{lineHeight: '20px', fontSize: '16px',fontWeight:500}}>{page.order_shipping}</span>
                          </div>
                        </div>
                        <div className="tw-mb-7">
                          <div className="tw-bg-white tw-pt-2 tw-pb-2 tw-pl-6 tw-pr-6">
                      <span className="d-flex flex-md-row">
                        <p className="float-start tw-p-2" style={{fontSize: '14px', lineHeight: '21px'}}>NB:</p>
                        <p className="tw-p-2" style={{fontSize: '14px', lineHeight: '21px'}}>Refresh this page after notification to see your updated offer status</p>
                      </span>
                          </div>
                        </div>
                        <button
                          className="tw-w-full tw-h-[45px] tw-bg-secondary tw-rounded-lg tw-border tw-border-white tw-text-white"
                          onClick={this.refresh}>
                          Refresh page &nbsp;&nbsp;&nbsp;
                          <img
                            src="/images/icons/refresh.png"
                            alt="shop"
                            className="tw-h-[16px] tw-w-[16px]"
                          />
                        </button>
                        <ErrorDisplay>{page.error?page.error.replace(regex,""):''}</ErrorDisplay>
                      </ConstraintUnique>
                    </div>
                  </>
                ) : page.order_status === 'accepted_by_seller' && page.virtual_account.status !== 'paid' ? (
                  <>
                    <div>
                      <div className="d-flex flex-column flex-md-row justify-content-between tw-gap-6">
                        <div className="store-container md:tw-w-[75%] sm:tw-w-full md:tw-pr-20">
                          <div className="md:tw-pl-5">
                            {page.order_status === 'accepted_by_seller' && (
                              <ConstraintUnique size={'100%'}>
                                <div className="tw-pt-7" style={{border: 0}}>
                                  <span>
                                    <p
                                      style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Offer accepted</p>
                                    <p style={{lineHeight: '21px', fontWeight: 400, fontSize: '14px'}}>Seller has accepted your offer. Please proceed to payment.</p>
                                  </span>
                                </div>
                              </ConstraintUnique>
                            )}

                          </div>

                          <div className="md:tw-pl-5 tw-mt-2">
                            <Constraint size={'100%'}>
                              <div className="tw-pt-7" style={{border: 0}}>
                                <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Payment</p>
                                <p style={{lineHeight: '21px', fontWeight: 400, fontSize: '14px'}}>Make payment to the account below</p>
                              </div>
                              <hr className="tw-mt-2 tw-mb-2" style={{borderTop: '1px solid #bbb'}}/>
                            </Constraint>

                            <Constraint size={'100%'}>
                              {(page.order_shipping.startsWith("Gokada") || page.order_shipping.startsWith("Fez")) && page.virtual_account && page.virtual_account.status === 'pending' ? (
                                <>
                                  <div className="tw-pt-1 tw-pb-1" style={{border: 0}}>
                                    <div className="tw-mt-2">
                                      <span
                                        style={{lineHeight: '14px', fontWeight: 200, fontSize: '14px'}}>Bank name</span><br/>
                                      <span style={{
                                        lineHeight: '14px',
                                        fontWeight: 450,
                                        fontSize: '14px'
                                      }}>{page.virtual_account.bank_name}</span>
                                    </div>
                                    <div
                                      className="tw-pt-3 d-flex flex-md-row justify-content-between align-content-center">
                                      <div className="float-start">
                                        <span style={{lineHeight: '14px', fontWeight: 200, fontSize: '14px'}}>Account number</span><br/>
                                        <span style={{
                                          lineHeight: '14px',
                                          fontWeight: 450,
                                          fontSize: '14px'
                                        }}>{page.virtual_account.account_number}</span>
                                      </div>
                                      <div className="float-end align-middle tw-bg-[#F6F5FF]" style={{
                                        padding: '10px 5px',
                                        border: '1px solid #F6F5FF',
                                        borderRadius: '15px'
                                      }}>
                                        <span className="tw-text-base"
                                              style={{cursor: 'pointer', color: '#6D60F6', fontSize: '14px'}}
                                              onClick={this.copyAccountNumber}>
                                           &nbsp;&nbsp;<img
                                          src="/images/icons/copy2.svg"
                                          alt="copy"
                                          className="tw-h-[14px] tw-w-[14px]"
                                        /> &nbsp;{this.state.clicked ? 'Copied' : 'Copy'}&nbsp;&nbsp;
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      className="tw-pt-3 d-flex flex-md-row justify-content-between align-content-center">
                                      <div className="float-start">
                                        <span style={{lineHeight: '14px', fontWeight: 200, fontSize: '14px'}}>Total amount (delivery inclusive)</span><br/>
                                        <span style={{
                                          lineHeight: '14px',
                                          fontWeight: 450,
                                          fontSize: '14px'
                                        }}>{formatCurrency(parseFloat(page.virtual_account.amount), 'NGN')}</span>
                                      </div>
                                      <div className="float-end align-middle tw-bg-[#F6F5FF]" style={{
                                        padding: '10px 5px',
                                        border: '1px solid #F6F5FF',
                                        borderRadius: '15px'
                                      }}>
                                        <span className="tw-text-base" style={{
                                          cursor: 'pointer',
                                          color: '#6D60F6',
                                          lineHeight: '14px',
                                          fontSize: '14px'
                                        }} onClick={this.copyItem}>
                                           &nbsp;&nbsp;<img
                                          src="/images/icons/copy2.svg"
                                          alt="copy"
                                          className="tw-h-[14px] tw-w-[14px]"
                                        /> &nbsp;{this.state.clickedToo ? 'Copied' : 'Copy'}&nbsp;&nbsp;
                                        </span>
                                      </div>
                                    </div>
                                    <div className="tw-pt-3">
                                      <span
                                        style={{lineHeight: '14px', fontWeight: 200, fontSize: '14px'}}>Reference</span><br/>
                                      <span style={{
                                        lineHeight: '14px',
                                        fontWeight: 450,
                                        fontSize: '14px'
                                      }}>{page.virtual_account.reference}</span>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <Notice>Your item is getting prepared for shipment!</Notice>
                                  <DeliveryProgress/>
                                </>
                              )}
                              <hr className="tw-mt-2 tw-mb-2" style={{borderTop: '1px solid #bbb'}}/>
                              <div className="d-flex flex-md-row justify-content-between align-content-center">
                                <div className="tw-mt-5 d-flex flex-md-row flex-column gap-4">
                                  <div>
                                <span className="d-flex gap-0 flex-md-row justify-content-between align-content-center">
                                  <span className="float-start tw-p-1">
                                    <img
                                      src="/images/icons/medal-star.png"
                                      alt="medal-star"
                                      className="size-24px"
                                    />
                                  </span>
                                  <span>
                                    <span className="tw-p-2" style={{
                                      fontSize: '14px',
                                      lineHeight: '14px',
                                      fontWeight: 400
                                    }}>Certified</span>
                                    <br/>
                                    <span className="tw-p-2"
                                          style={{fontSize: '14px', lineHeight: '14px', fontWeight: 200}}>By NICC</span>
                                  </span>
                                </span>
                                  </div>

                                  <div>
                                <span className="d-flex gap-0 flex-md-row justify-content-between align-content-center">
                                  <span className="float-start tw-p-1">
                                    <img
                                      src="/images/icons/shield-tick.png"
                                      alt="medal-star"
                                      className="size-24px"
                                    />
                                  </span>
                                  <span>
                                    <span className="tw-p-2" style={{
                                      fontSize: '14px',
                                      lineHeight: '14px',
                                      fontWeight: 400
                                    }}>Secured</span>
                                    <br/>
                                    <span className="tw-p-2"
                                          style={{fontSize: '14px', lineHeight: '14px', fontWeight: 200}}>Payments</span>
                                  </span>
                                </span>
                                  </div>

                                  <div>
                                <span className="d-flex gap-0 flex-md-row justify-content-between align-content-center">
                                  <span className="float-start tw-p-1">
                                    <img
                                      src="/images/icons/like-shapes.png"
                                      alt="medal-star"
                                      className="size-24px"
                                    />
                                  </span>
                                  <span>
                                    <span className="tw-p-2" style={{
                                      fontSize: '14px',
                                      lineHeight: '14px',
                                      fontWeight: 400
                                    }}>Verified</span>
                                    <br/>
                                    <span className="tw-p-2"
                                          style={{fontSize: '14px', lineHeight: '14px', fontWeight: 200}}>Merchant</span>
                                  </span>
                                </span>
                                  </div>
                                </div>
                                <div className="tw-mt-5 float-end">
                                <span className="d-flex gap-0 flex-md-row justify-content-between align-content-center">
                                  <span className="float-start tw-p-1">
                                    Powered by &nbsp;<img
                                      src="/images/icons/gokada.png"
                                      alt="medal-star"
                                      className="size-24px"
                                    />
                                  </span>
                                </span>
                                </div>
                              </div>
                            </Constraint>

                            <div className="tw-bg-[#FFF8EB] tw-w-full">
                              <Constraint size={'100%'}>
                                <div className="tw-mt-7">
                                  <div className=" tw-pt-2 tw-pb-2">
                      <span className="d-flex flex-md-row">
                        <span className="float-start tw-p-2" style={{fontSize: '14px', lineHeight: '21px'}}>
                           <img
                             src="/images/icons/essentional.png"
                             alt="essential"
                             className="size-24px"
                           />
                        </span>
                        <p className="tw-p-2" style={{fontSize: '14px', lineHeight: '21px'}}>Your payment will not be sent to the seller until 24 hours after your order is delivered.</p>
                      </span>
                                  </div>
                                </div>
                              </Constraint>
                            </div>

                          </div>
                        </div>
                        <div className="added-item tw-hidden md:tw-block tw-w-[23%] tw-mt-1">
                          <h2 className="tw-mb-2 tw-text-lg tw-font-semibold tw-text-gray-900 tw-dark:text-white">Order
                            Summary and checkout</h2>
                          <Backdrop offset={altOffset} style={{marginBottom: '0'}}>
                            <Constraint style={{paddingLeft: '0', alignContent: 'center'}}>
                              <ProductDisplayUnique image={page.primary_image} title={page.title} price={page.price}/>
                            </Constraint>
                          </Backdrop>
                          <div className="d-flex flex-column flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                            <div className="float-start">
                              <span className="font-weight-lighter" style={{lineHeight: '18px'}}>Item price:</span>
                            </div>
                            <div className="float-end">
                              <span className="font-weight-lighter"
                                    style={{lineHeight: '18px'}}>{formatCurrency(page.price)}</span>
                            </div>
                          </div>


                          { page.shipping_price > 0 && (
                            <div className="d-flex flex-column flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                              <div className="float-start">
                                <span className="font-weight-lighter" style={{lineHeight:'18px'}}>Delivery fee:</span>
                              </div>
                              <div className="float-end">
                                <span className="font-weight-lighter" style={{lineHeight:'18px'}}> +{formatCurrency(page.happy_hour_status === 1 ? 100 : (page.shipping_price - page.order_discount))}</span>
                                {/*{page.shipping_price > (page.virtual_account.amount - page.price - page.used_bonus_amount - page.order_discount) && (*/}
                                {/*  <><br/><span style={{fontStyle:'italic', fontSize:'10px', float:'inline-end',textDecoration:'line-through'}}>{formatCurrency(page.shipping_price)}</span></>*/}
                                {/*)}*/}
                                {(page.order_discount > 0 || page.happy_hour_status === 1) && (
                                  <><br/><span style={{fontStyle:'italic', fontSize:'10px', float:'inline-end',textDecoration:'line-through'}}>{formatCurrency(page.shipping_price)}</span></>
                                )}
                              </div>
                            </div>
                          )}

                          { page.happy_hour_status === 1 ? (
                            <></>
                          ) : (

                            <>
                              {/*{ page.shipping_price > 0 && (*/}
                              {/*  <div className="d-flex flex-column flex-md-row justify-content-between tw-mt-0 tw-mb-4">*/}
                              {/*    <div className="float-start">*/}
                              {/*      <span className="font-weight-lighter" style={{lineHeight:'18px'}}>Delivery fee:</span>*/}
                              {/*    </div>*/}
                              {/*    <div className="float-end">*/}
                              {/*      <span className="font-weight-lighter" style={{lineHeight:'18px'}}> +{formatCurrency(page.happy_hour_status === 1 ? 100 : (page.shipping_price - page.order_discount))}</span>*/}
                              {/*      /!*{page.shipping_price > (page.virtual_account.amount - page.price - page.used_bonus_amount - page.order_discount) && (*!/*/}
                              {/*      /!*  <><br/><span style={{fontStyle:'italic', fontSize:'10px', float:'inline-end',textDecoration:'line-through'}}>{formatCurrency(page.shipping_price)}</span></>*!/*/}
                              {/*      /!*)}*!/*/}
                              {/*      {(page.order_discount > 0 || page.happy_hour_status === 1) && (*/}
                              {/*        <><br/><span style={{fontStyle:'italic', fontSize:'10px', float:'inline-end',textDecoration:'line-through'}}>{formatCurrency(page.shipping_price)}</span></>*/}
                              {/*      )}*/}
                              {/*    </div>*/}
                              {/*  </div>*/}
                              {/*)}*/}

                              {page.used_bonus_amount >= 5 && (
                                <div className="d-flex flex-column flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                                  <div className="float-start">
                                    <span className="font-weight-lighter" style={{lineHeight:'18px'}}>Bonus:</span>
                                  </div>
                                  <div className="float-end">
                                    <span className="font-weight-lighter" style={{lineHeight:'18px'}}> -{formatCurrency(page.used_bonus_amount)}</span>
                                  </div>
                                </div>
                              )}

                              {page.order_discount > 0 && (
                                <div className="d-flex flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                                  <div className="float-start">
                                    <span className="font-weight-lighter" style={{lineHeight:'18px'}}>Discount:</span>
                                  </div>
                                  <div className="float-end">
                                    <span className="font-weight-lighter" style={{lineHeight:'18px'}}> -{formatCurrency((page.order_discount))}</span>
                                  </div>
                                </div>
                              )}
                            </>
                          )}


                          <div className="d-flex flex-column flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                            <div className="float-start">
                              <span className="font-weight-bolder tw-font-semibold" style={{lineHeight:'28px', fontSize:'17px'}}>Total</span>
                            </div>
                            <div className="float-end">
                              <span className="font-weight-bolder tw-font-semibold" style={{lineHeight:'28px', fontSize:'17px', color:'#6D60F6'}}> {formatCurrency(parseFloat(page.virtual_account.amount), 'NGN')}</span>
                            </div>
                          </div>
                          <button
                            className="tw-w-full tw-h-[45px] tw-bg-secondary tw-rounded-lg tw-border tw-border-white tw-text-white tw-mt-6"
                            onClick={this.verifyPayment} disabled={page.order_status !== 'accepted_by_seller'}>
                            Payment status &nbsp;&nbsp;&nbsp;
                            <img
                              src="/images/icons/refresh.png"
                              alt="shop"
                              className="tw-h-[16px] tw-w-[16px]"
                            />
                          </button>
                          {page.error && (
                            <p className="tw-w-full text-center"
                               style={{fontSize: '14px', color: 'hotpink', fontWeight: 'bold',}}>{page.error}</p>
                          )}

                        </div>
                        <div className="added-item md:tw-hidden tw-mt-10">
                          <h2 className="tw-mb-2 tw-text-lg tw-font-semibold tw-text-gray-900 tw-dark:text-white">Order
                            Summary and checkout</h2>
                          <Backdrop offset={altOffset} style={{marginBottom: '0'}}>
                            <Constraint style={{paddingLeft: '0', alignContent: 'center'}}>
                              <ProductDisplayUnique image={page.primary_image} title={page.title} price={page.price}/>
                            </Constraint>
                          </Backdrop>
                          <div className="d-flex flex-md-row flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                            <span className="float-start font-weight-lighter"
                                  style={{lineHeight: '18px'}}>Item price:</span>
                            <span className="float-end font-weight-lighter"
                                  style={{lineHeight: '18px'}}>{formatCurrency(page.price)}</span>
                          </div>

                          { page.shipping_price > 0 && (
                            <div className="d-flex flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                              <div className="float-start">
                                <span className="font-weight-lighter" style={{lineHeight:'18px'}}>Delivery fee:</span>
                              </div>
                              <div className="float-end">
                                <span className="font-weight-lighter" style={{lineHeight:'18px'}}> +{formatCurrency(page.happy_hour_status === 1 ? 100 : (page.shipping_price - page.order_discount))}</span>
                                {/*{page.shipping_price > (page.virtual_account.amount - page.price - page.used_bonus_amount - page.order_discount) && (*/}
                                {/*  <><br/><span style={{fontStyle:'italic', fontSize:'10px', float:'inline-end',textDecoration:'line-through'}}>{formatCurrency(page.shipping_price)}</span></>*/}
                                {/*)}*/}
                                {(page.order_discount > 0 || page.happy_hour_status === 1) && (
                                  <><br/><span style={{fontStyle:'italic', fontSize:'10px', float:'inline-end',textDecoration:'line-through'}}>{formatCurrency(page.shipping_price)}</span></>
                                )}
                              </div>
                            </div>
                          )}

                          { page.happy_hour_status === 1 ? (
                            <></>
                          ) : (
                            <>
                              {/*{ page.shipping_price > 0 && (*/}
                              {/*  <div className="d-flex flex-md-row justify-content-between tw-mt-0 tw-mb-4">*/}
                              {/*    <div className="float-start">*/}
                              {/*      <span className="font-weight-lighter" style={{lineHeight:'18px'}}>Delivery fee:</span>*/}
                              {/*    </div>*/}
                              {/*    <div className="float-end">*/}
                              {/*      <span className="font-weight-lighter" style={{lineHeight:'18px'}}> +{formatCurrency(page.happy_hour_status === 1 ? 100 : (page.shipping_price - page.order_discount))}</span>*/}
                              {/*      /!*{page.shipping_price > (page.virtual_account.amount - page.price - page.used_bonus_amount - page.order_discount) && (*!/*/}
                              {/*      /!*  <><br/><span style={{fontStyle:'italic', fontSize:'10px', float:'inline-end',textDecoration:'line-through'}}>{formatCurrency(page.shipping_price)}</span></>*!/*/}
                              {/*      /!*)}*!/*/}
                              {/*      {(page.order_discount > 0 || page.happy_hour_status === 1) && (*/}
                              {/*        <><br/><span style={{fontStyle:'italic', fontSize:'10px', float:'inline-end',textDecoration:'line-through'}}>{formatCurrency(page.shipping_price)}</span></>*/}
                              {/*      )}*/}
                              {/*    </div>*/}
                              {/*  </div>*/}
                              {/*)}*/}

                              {page.used_bonus_amount >= 5 && (
                                <div className="d-flex flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                                  <span className="float-start font-weight-lighter" style={{lineHeight:'18px'}}>Bonus:</span>
                                  <span className="float-end font-weight-lighter" style={{lineHeight:'18px'}}> -{formatCurrency(page.used_bonus_amount)}</span>
                                </div>
                              )}

                              {page.order_discount > 0 && (
                                <div className="d-flex flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                                  <div className="float-start">
                                    <span className="font-weight-lighter" style={{lineHeight:'18px'}}>Discount:</span>
                                  </div>
                                  <div className="float-end">
                                    <span className="font-weight-lighter" style={{lineHeight:'18px'}}> -{formatCurrency((page.order_discount))}</span>
                                  </div>
                                </div>
                              )}
                            </>
                          )}

                          <div className="d-flex flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                            <div className="float-start">
                              <span className="font-weight-bolder tw-font-semibold" style={{lineHeight:'28px', fontSize:'17px'}}>Total</span>
                            </div>
                            <div className="float-end">
                              <span className="font-weight-bolder tw-font-semibold" style={{lineHeight:'28px', fontSize:'17px', color:'#6D60F6'}}> {formatCurrency(parseFloat(page.virtual_account.amount), 'NGN')}</span>
                            </div>
                          </div>

                          <button
                            className="tw-w-full tw-h-[45px] tw-bg-secondary tw-rounded-lg tw-border tw-border-white tw-text-white"
                            onClick={this.refresh} disabled={page.order_status !== 'accepted_by_seller'}>
                            Payment status &nbsp;&nbsp;&nbsp;
                            <img
                              src="/images/icons/refresh.png"
                              alt="shop"
                              className="tw-h-[16px] tw-w-[16px]"
                            />

                          </button>
                          {page.error && (
                            <p className="tw-w-full text-center"
                               style={{fontSize: '14px', color: 'hotpink', fontWeight: 'bold',}}>{page.error}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ):(
                  <>
                    <div>
                      <div className="d-flex flex-md-row justify-content-between gap-10">
                        <div className="store-container tw-w-full md:tw-pr-5">
                          <div className="md:tw-hidden tw-w-full md:tw-mt-[10%]">
                            <div className="tw-pl-[10%] tw-pr-[10%]" style={{textAlign:'center'}}>
                              <p style={{lineHeight: '24px', fontWeight: 600, fontSize: '17px'}}>Congratulations!</p>
                              <p style={{lineHeight: '21px', fontWeight: 400, fontSize:'14px'}}>
                                Congratulations on your {page.transaction_count < 2 ? 'first' : ''} POD transaction. You can earn {page.order_shipping.startsWith("Gokada") || page.order_shipping.startsWith("Fez")?(<span style={{fontWeight:500}}>{formatCurrency(3000)}</span>):(<span style={{fontWeight:400}}>{formatCurrency(5)}</span>)} by referring 5 of your friends
                              </p>
                            </div>
                          </div>
                          <div className="md:tw-pl-5">
                            {(page.order_status === 'accepted_by_seller'
                              || page.order_status === 'shipped_by_seller'
                              || page.order_status === 'delivered_to_buyer'
                              || page.order_status === 'could_not_be_shipped'
                              || page.order_status === 'accepted_by_seller_exception_by_shipper'
                              || page.order_status === 'order_completed') && (
                              <>
                                <ConstraintUnique size={'100%'}>
                                  <div className="tw-pt-7" style={{border: 0}}>
                                  <span>
                                    <span style={{fontWeight:500,fontSize:'15px',lineHeight:'21px'}}>Status: </span>
                                    {page.has_order ? (
                                      {
                                        offer_requested_by_buyer: <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Offer pending</p>,
                                        no_response_from_seller: <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Offer expired</p>,
                                        accepted_by_seller: page.is_buyer ? (
                                          <>
                                            <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>{page.shipment_tracking?.status === 'delivered' ? 'Delivered' :!page.shipment_tracking?'Processing shipment...' : 'Delivery pending'}</p>
                                            <p style={{lineHeight: '21px', fontWeight: 400, fontSize: '14px'}}>Seller has accepted your order and is preparing to ship your items. Refresh this page after notification to see your updated offer status</p>
                                          </>
                                        ) : (
                                          <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Ready to ship</p>
                                        ),
                                        accepted_by_seller_exception_by_shipper: <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Item is pending</p>,
                                        shipped_by_seller: <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Item shipped</p>,
                                        delivered_to_buyer: <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Item delivered</p>,
                                        not_accepted_by_seller: <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Offer declined</p>,
                                        not_accepted_by_buyer: <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Offer declined</p>,
                                        failed_to_secure_buyer_funds: page.is_buyer ? (
                                          <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Update needed</p>
                                        ) : (
                                          <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Buyer update needed</p>
                                        ),
                                        failed_to_secure_buyer_funds_insufficient: page.is_buyer ? (
                                          <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Update needed</p>
                                        ) : (
                                          <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Buyer update needed</p>
                                        ),
                                        buyer_updated_card_after_failure: <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Offer pending</p>,
                                        shipping_rate_changed: <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Offer failed</p>,
                                        could_not_be_shipped: page.is_buyer ? (
                                          <>
                                            <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>{page.shipment_tracking?.status === 'delivered' ? 'Delivered' :!page.shipment_tracking?'Processing shipment...' : 'Delivery pending'}</p>
                                            <p style={{lineHeight: '21px', fontWeight: 400, fontSize: '14px'}}>Seller has accepted your order and is preparing to ship your items. Refresh this page after notification to see your updated offer status</p>
                                          </>
                                        ) : (
                                          <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Not shipped</p>
                                        ),
                                        delivery_exception: <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Delivery exception</p>,
                                        not_shipped_by_seller: <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Not shipped</p>,
                                        return_not_shipped_by_buyer: <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Return not shipped</p>,
                                        order_completed: <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Transaction completed</p>,
                                        order_completed_with_error: <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Transaction error</p>,
                                        order_return_requested: <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Return initiated</p>,
                                        order_return_shipped: <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Return shipped</p>,
                                        order_return_delivered: <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Return delivered</p>,
                                        order_flagged_as_fraud: <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Offer failed</p>,
                                        order_return_completed: <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Return completed</p>,
                                      }[page.order_status] || (
                                        <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Unknown item status error, please contact us. (E501)</p>
                                      )
                                    ): page.is_buyer ? (
                                      <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Offer pending</p>
                                    ) : page.has_offers ? (
                                      <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Offer pending</p>
                                    ) : (
                                      <p style={{lineHeight: '24px', fontWeight: 700, fontSize: '16px'}}>Waiting for a buyer</p>
                                    )}
                                  </span>
                                  </div>
                                  <div className="tw-mt-7 tw-mb-7">
                                    <ProductDisplayUnique image={page.primary_image} title={page.title} price={page.price}/>
                                  </div>
                                  <hr className="tw-mt-2 tw-mb-2" style={{borderTop: '1px solid #bbb'}}/>
                                  <div className="tw-mt-7 tw-mb-7">
                                    <div className="d-flex flex-md-row flex-md-row justify-content-between tw-mt-2 tw-mb-2">
                            <span className="float-start font-weight-lighter"
                                  style={{lineHeight: '20px', fontSize: '16px'}}>Order ID:</span>
                                      <span className="float-end font-weight-lighter"
                                            style={{lineHeight: '20px', fontSize: '16px',fontWeight:500}}>{page.order_uid}</span>
                                    </div>
                                    <div className="d-flex flex-md-row justify-content-between tw-mt-2 tw-mb-2">
                            <span className="float-start font-weight-lighter"
                                  style={{lineHeight: '20px', fontSize: '16px'}}>Seller:</span>
                                      <span className="float-end font-weight-lighter"
                                            style={{lineHeight: '20px', fontSize: '16px',fontWeight:500}}>@{page.seller}</span>
                                    </div>
                                    <div className="d-flex flex-md-row flex-md-row justify-content-between tw-mt-2 tw-mb-2">
                            <span className="float-start font-weight-lighter"
                                  style={{lineHeight: '20px', fontSize: '16px'}}>Shipping:</span>
                                      <span className="float-end font-weight-lighter"
                                            style={{lineHeight: '20px', fontSize: '16px',fontWeight:500}}>{page.order_shipping}</span>
                                    </div>
                                  </div>
                                </ConstraintUnique>
                                <div className="tw-mt-8 tw-mb-2">
                                  <p style={{lineHeight: '24px', fontWeight: 600, fontSize: '16px'}}>
                                    {page.shipment_tracking?.status === 'pending' ? 'Your item is getting prepared for shipment!':page.shipment_tracking?.status==='delivered'?'Your item has been delivered':!page.shipment_tracking?'We are processing your item shipment':'Your item has been shipped'}
                                  </p>
                                </div>
                                <span className="tw-hidden md:tw-block">
                                  <DeliveryProgressV2 />
                                </span>
                                <span className="md:tw-hidden">
                                  <DeliveryProgress />
                                </span>
                              </>
                            )}
                          </div>
                          {page.shipment_tracking?.status === 'delivered' && page.order_status !== 'order_completed'  && (<>
                              <button
                                className="tw-mt-2 tw-w-full tw-h-[45px] tw-bg-secondary tw-rounded-lg tw-border tw-border-white tw-text-white"
                                onClick={this.openOrderReceivedModal}>
                                I have received my order
                              </button>
                              {/*<HowItWorksDisplay onClick={this.toggle}>How does this work?</HowItWorksDisplay>*/}
                          </>
                            )}
                          {page.order_status !== 'order_completed'  && (
                            <button
                              className="tw-w-full tw-h-[45px] tw-bg-white tw-rounded-lg tw-border-none tw-border-white tw-text-secondary"
                              onClick={this.refresh}>
                              Refresh &nbsp;&nbsp;&nbsp;
                              <img
                                src="/images/icons/refreshBlue.png"
                                alt="shop"
                                className="tw-h-[16px] tw-w-[16px]"
                              />
                            </button>
                          )}

                          <ErrorDisplay style={{color:'black', fontWeight:500,fontStyle:"italics"}}>{page.error?page.error.replace(regex,""):''}</ErrorDisplay>
                        </div>
                        <div className="tw-hidden md:tw-block tw-w-full md:tw-mt-[10%]">
                          <div className="tw-pl-[30%] tw-pr-[10%]" style={{textAlign:'center'}}>
                            <p style={{lineHeight: '24px', fontWeight: 600, fontSize: '17px'}}>Congratulations!</p>
                            <p style={{lineHeight: '21px', fontWeight: 400, fontSize:'14px'}}>
                              Congratulations on your {page.first_transaction?'first':''} POD transaction. You can earn {page.order_shipping.startsWith("Gokada") || page.order_shipping.startsWith("Fez")?(<span style={{fontWeight:500}}>{formatCurrency(3000)}</span>):(<span style={{fontWeight:400}}>{formatCurrency(5)}</span>)} by referring 5 of your friends
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </>
          ) : (
            <>
              <Backdrop>
                <Constraint>
                  {page.has_order ? (
                    {
                      offer_requested_by_buyer: <OverallStatus>Offer pending</OverallStatus>,
                      no_response_from_seller: <OverallStatus>Offer expired</OverallStatus>,
                      accepted_by_seller: page.is_buyer ? (
                        <OverallStatus>Accepted, preparing to ship</OverallStatus>
                      ) : (
                        <OverallStatus>Ready to ship</OverallStatus>
                      ),
                      accepted_by_seller_exception_by_shipper: <OverallStatus>Item is pending</OverallStatus>,
                      shipped_by_seller: <OverallStatus>Item shipped</OverallStatus>,
                      delivered_to_buyer: <OverallStatus>Item delivered</OverallStatus>,
                      not_accepted_by_seller: <OverallStatus>Offer declined</OverallStatus>,
                      not_accepted_by_buyer: <OverallStatus>Offer declined</OverallStatus>,
                      failed_to_secure_buyer_funds: page.is_buyer ? (
                        <OverallStatus>Update needed</OverallStatus>
                      ) : (
                        <OverallStatus>Buyer update needed</OverallStatus>
                      ),
                      failed_to_secure_buyer_funds_insufficient: page.is_buyer ? (
                        <OverallStatus>Update needed</OverallStatus>
                      ) : (
                        <OverallStatus>Buyer update needed</OverallStatus>
                      ),
                      buyer_updated_card_after_failure: <OverallStatus>Offer pending</OverallStatus>,
                      shipping_rate_changed: <OverallStatus>Offer failed</OverallStatus>,
                      could_not_be_shipped: <OverallStatus>Not shipped</OverallStatus>,
                      delivery_exception: <OverallStatus>Delivery exception</OverallStatus>,
                      not_shipped_by_seller: <OverallStatus>Not shipped</OverallStatus>,
                      return_not_shipped_by_buyer: <OverallStatus>Return not shipped</OverallStatus>,
                      order_completed: <OverallStatus>Transaction completed</OverallStatus>,
                      order_completed_with_error: <OverallStatus>Transaction error</OverallStatus>,
                      order_return_requested: <OverallStatus>Return initiated</OverallStatus>,
                      order_return_shipped: <OverallStatus>Return shipped</OverallStatus>,
                      order_return_delivered: <OverallStatus>Return delivered</OverallStatus>,
                      order_flagged_as_fraud: <OverallStatus>Offer failed</OverallStatus>,
                      order_return_completed: <OverallStatus>Return completed</OverallStatus>,
                    }[page.order_status] || (
                      <OverallStatus>Unknown item status error, please contact us. (E501)</OverallStatus>
                    )
                  ) : page.is_buyer ? (
                    <OverallStatus>Offer pending</OverallStatus>
                  ) : page.has_offers ? (
                    <OverallStatus>Offer pending</OverallStatus>
                  ) : (
                    <OverallStatus>Waiting for a buyer</OverallStatus>
                  )}

                  <ItemDisplay/>
                </Constraint>

                <ErrorDisplay>{page.error}</ErrorDisplay>
              </Backdrop>

              {page.has_order ? (
                {
                  offer_requested_by_buyer: (
                    <Constraint>
                      <Notice>
                        <p>Your purchase offer is pending.</p>
                        <p>You will be notified as soon as the seller accepts it.</p>
                      </Notice>
                    </Constraint>
                  ),
                  accepted_by_seller: page.is_seller ? (
                    <Constraint>
                      <Notice>
                        <p>Awesome, it's sold!</p>
                        {page.shipment_instructions ? (
                          <>
                            <p>Now let's ship it.</p>
                          </>
                        ) : (
                          <p>We are waiting for the buyer's payment. We'll let you know as soon
                            as this happens so you can ship your item.</p>
                        )}
                      </Notice>

                      {page.shipment_instructions && (
                        <>
                          <Spring native from={startAnimation} to={endAnimation} config={config.gentle}>
                            {animation => (
                              <animated.div style={animation}>
                                <Container>
                                  {page.shipment_instructions.shipper === 'Fez' ? (
                                    <>


                                      <Row>
                                        <Number>1</Number>
                                        <Title>Put your stuff in a box</Title>
                                        <Instruction>Put your {page.shipment_instructions.item_title} in a box or some other kind of packaging to ship.</Instruction>
                                      </Row>

                                      <Row>
                                        <Number>2</Number>
                                        <Title>
                                          {userCountry() === 'NG' ? 'Wait for your driver for pickup' : 'Clearly label the box'}
                                        </Title>
                                        {userCountry() !== 'NG' && (
                                          <Instruction>Make sure every part of the label is readable so it ships easily!</Instruction>
                                        )}
                                      </Row>

                                      {userCountry() !== 'NG' && (
                                        <Row>
                                          <Number>3</Number>
                                          {page.shipment_instructions.shipper_will_pickup ? (
                                            <>
                                              <Title>Pickup</Title>
                                              <Instruction>
                                                <div>We are sending someone from {page.shipment_instructions.shipper}.</div>
                                                <EstimatedPickup>{page.shipment_instructions.estimated_pickup}</EstimatedPickup>
                                              </Instruction>
                                            </>
                                          ) : (
                                            <>
                                              <Title>Dropoff your item</Title>
                                              <Instruction>
                                                Ship this order at your nearest {page.shipment_instructions.shipper} location.
                                                <Places>
                                                  {page.shipment_instructions.dropoff_locations.map((location, index) => (
                                                    <Place key={index} onClick={() => this.showModal(index)}>
                                                      <NameAndAddress location={location} />
                                                      <DetailsLink>View details &amp; map</DetailsLink>
                                                    </Place>
                                                  ))}
                                                </Places>
                                              </Instruction>
                                            </>
                                          )}
                                        </Row>
                                      )}
                                    </>
                                    ) : (
                                      <>
                                        <Row>
                                          <Number>1</Number>
                                          <div>
                                            <Button disabled={page.shipment_instructions.label_url && page.shipment_instructions.label_url.length < 5} onClick={() => this.onPrintLabelButtonClick(page.shipment_instructions.label_url)} icon="print"
                                                    style={{ background: `${primaryColor.hex()}`, width: '90%'}}>
                                              {page.shipment_instructions.label_url && page.shipment_instructions.label_url.length > 5 ? 'Get your QR code' : 'Shipment processing...'}
                                            </Button>
                                          </div>
                                        </Row>

                                        <Row>
                                          <Number>2</Number>
                                          <Title>Put your stuff in a box</Title>
                                          <Instruction>Put your {page.shipment_instructions.item_title} in a box or some other kind of packaging to ship.</Instruction>
                                        </Row>

                                        <Row>
                                          <Number>3</Number>
                                          <Title>
                                            {userCountry() === 'NG' ? 'Wait for your driver for pickup' : 'Clearly label the box'}
                                          </Title>
                                          {userCountry() !== 'NG' && (
                                            <Instruction>Make sure every part of the label is readable so it ships easily!</Instruction>
                                          )}
                                        </Row>

                                        {userCountry() !== 'NG' && (
                                          <Row>
                                            <Number>4</Number>
                                            {page.shipment_instructions.shipper_will_pickup ? (
                                              <>
                                                <Title>Pickup</Title>
                                                <Instruction>
                                                  <div>We are sending someone from {page.shipment_instructions.shipper}.</div>
                                                  <EstimatedPickup>{page.shipment_instructions.estimated_pickup}</EstimatedPickup>
                                                </Instruction>
                                              </>
                                            ) : (
                                              <>
                                                <Title>Dropoff your item</Title>
                                                <Instruction>
                                                  Ship this order at your nearest {page.shipment_instructions.shipper} location.
                                                  <Places>
                                                    {page.shipment_instructions.dropoff_locations.map((location, index) => (
                                                      <Place key={index} onClick={() => this.showModal(index)}>
                                                        <NameAndAddress location={location} />
                                                        <DetailsLink>View details &amp; map</DetailsLink>
                                                      </Place>
                                                    ))}
                                                  </Places>
                                                </Instruction>
                                              </>
                                            )}
                                          </Row>
                                        )}
                                      </>
                                    )}

                                </Container>
                              </animated.div>
                            )}
                          </Spring>

                          {page.shipment_instructions.dropoff_locations && (
                            <Modal showModal={this.modalIsVisible} onCancel={this.closeModal} withCloseButton>
                              <ModalContents>
                                <NameAndAddress location={page.shipment_instructions.dropoff_locations[this.locationIndex]} includePhone />
                                <HoursOfOperation location={page.shipment_instructions.dropoff_locations[this.locationIndex]} />
                                <EmbeddedMap location={page.shipment_instructions.dropoff_locations[this.locationIndex]} />
                              </ModalContents>
                            </Modal>
                          )}


                          {/*<ShippingInstructions />*/}
                        </>
                      )}
                    </Constraint>
                  ) : (
                    <Constraint>
                      {(page.order_shipping.startsWith("Gokada") || page.order_shipping.startsWith("Fez")) && page.virtual_account && page.virtual_account.status === 'pending' ? (
                        <>
                          <Notice>The seller has accepted your offer. Please pay for the item using the next
                            information.</Notice>
                          <PaymentInfo>
                            <div>Account Number:</div>
                            <div>{page.virtual_account.account_number}</div>
                            <div>Reference:</div>
                            <div>{page.virtual_account.reference}</div>
                            <div>Bank Name:</div>
                            <div>{page.virtual_account.bank_name}</div>
                            <div>Amount:</div>
                            <div>
                              {formatCurrency(parseFloat(page.virtual_account.amount), 'NGN')}<br/>
                              <small><em>* Includes shipment cost</em></small>
                            </div>
                          </PaymentInfo>
                        </>
                      ) : (
                        <>
                          <Notice>Your item is getting prepared for shipment!</Notice>
                          <DeliveryProgress/>
                        </>
                      )}
                    </Constraint>
                  ),
                  order_return_requested: page.is_buyer ? (
                    <Constraint>
                      <Notice>
                        <p>Your return has been initiated.</p>
                        <p>Let's ship the item back.</p>
                      </Notice>
                      <ShippingInstructions/>
                    </Constraint>
                  ) : (
                    <Constraint>
                      <Notice>
                        <p>The buyer is preparing to return the item.</p>
                        <p>It will ship soon.</p>
                      </Notice>
                      <DeliveryProgress/>
                    </Constraint>
                  ),
                  shipped_by_seller: (
                    <>
                      {page.is_seller && !page.has_bank_account && (<BankAccountNotice>
                        Do not forget to add your bank account to receive your funds. <br/>
                        <Link to={"/my-account"} className="btn btn-primary">Add Your Account</Link>
                      </BankAccountNotice>)}
                      <Constraint>
                        <DeliveryProgress/>
                      </Constraint>
                    </>
                  ),
                  delivered_to_buyer: page.is_buyer ? (
                    <Constraint offset={`${buttonHeight / 2}rem`}>
                      {page.payButtonClicked || (
                        <Button onClick={page.completeOrder} isLoading={page.isCompleting}>
                          Confirm and pay seller
                        </Button>
                      )}
                      <Notice>
                        <p>Please look it over and verify it is as expected.</p>
                        <p>The transaction will automatically complete after 24 hours.</p>
                      </Notice>
                      <DeliveryProgress/>
                      <ReturnItemLink onClick={page.returnOrder}>An issue with your order?</ReturnItemLink>
                    </Constraint>
                  ) : (
                    <Constraint>
                      <Notice>
                        <p>The buyer has received the shipment.</p>
                        <p>Once it is verified your funds will be on the way!</p>
                      </Notice>
                      {page.is_seller && !page.has_bank_account && (<BankAccountNotice>
                        Do not forget to add your bank account to receive your funds. <br/>
                        <Link to={"/my-account"} className="btn btn-primary">Add Your Account</Link>
                      </BankAccountNotice>)}
                      <DeliveryProgress/>
                    </Constraint>
                  ),
                  failed_to_secure_buyer_funds: page.is_buyer ? (
                    <Constraint>
                      <Notice>
                        <p>
                          Your credit card failed to authorize when the seller accepted your offer. Please update your
                          payment method by clicking the button below:
                        </p>
                      </Notice>
                      <Button onClick={page.updateCreditCard}>Update payment method</Button>
                    </Constraint>
                  ) : (
                    <Constraint>
                      <Notice>
                        <p>
                          The buyers credit card has failed to authorize. They were notified that their payment method
                          needs
                          updating.
                        </p>
                        <p>We will let you know when they have done this.</p>
                      </Notice>
                    </Constraint>
                  ),
                  failed_to_secure_buyer_funds_insufficient: page.is_buyer ? (
                    <Constraint>
                      <Notice>
                        <p>
                          Your credit card failed to authorize when the seller accepted your offer. You have
                          insufficient funds. Please update your
                          payment method by clicking the button below:
                        </p>
                      </Notice>
                      <Button onClick={page.updateCreditCard}>Update payment method</Button>
                    </Constraint>
                  ) : (
                    <Constraint>
                      <Notice>
                        <p>
                          The buyers credit card has failed to authorize. The buyer has insufficient funds. They were
                          notified that their payment method needs
                          updating.
                        </p>
                        <p>We will let you know when they have done this.</p>
                      </Notice>
                    </Constraint>
                  ),
                  buyer_updated_card_after_failure: page.is_seller ? (
                    <Constraint offset={`${buttonHeight / 2}rem`}>
                      <Button to={url('manage-order-page', {uid: page.order_uid})}>Accept and print label</Button>
                      <Notice>
                        <p>The buyer has updated their payment method.</p>
                        <p>Click the button to confirm and print the shipping label.</p>
                      </Notice>
                    </Constraint>
                  ) : (
                    <Constraint>
                      <Notice>
                        <p>Thank you for updating your payment method.</p>
                        <p>
                          We are waiting on the seller to confirm the shipping selection you chose, check back here for
                          updates.
                        </p>
                      </Notice>
                    </Constraint>
                  ),
                  shipping_rate_changed: (
                    <Constraint>
                      <Notice>
                        This order has failed because the shipping rate changed before the order was accepted.
                      </Notice>
                    </Constraint>
                  ),
                  could_not_be_shipped: (
                    <Constraint>
                      <DeliveryProgress/>
                    </Constraint>
                  ),
                  delivery_exception: (
                    <Constraint>
                      <DeliveryProgress/>
                    </Constraint>
                  ),
                  not_shipped_by_seller: (
                    <Constraint>
                      <DeliveryProgress/>
                    </Constraint>
                  ),
                  return_not_shipped_by_buyer: (
                    <Constraint>
                      <DeliveryProgress/>
                    </Constraint>
                  ),
                  order_completed: page.is_buyer ? (
                    <Constraint>
                      <Notice>This purchase has been completed.</Notice>
                      <DeliveryProgress/>
                    </Constraint>
                  ) : (
                    <Constraint>
                      <Notice>
                        <p>This purchase has been completed.</p>
                        <p>Your money is on its way!</p>
                      </Notice>
                      <DeliveryProgress/>
                    </Constraint>
                  ),
                  order_completed_with_error: (
                    <Constraint>
                      <Notice>This order has an error, please contact us (E9001).</Notice>
                    </Constraint>
                  ),
                  order_return_shipped: (
                    <Constraint>
                      <DeliveryProgress/>
                    </Constraint>
                  ),
                  order_return_delivered: (
                    <Constraint>
                      <DeliveryProgress/>
                    </Constraint>
                  ),
                  order_flagged_as_fraud: (
                    <Constraint>
                      <Notice>This order has failed, please contact us (E9002).</Notice>
                    </Constraint>
                  ),
                  order_return_completed: (
                    <Constraint>
                      <DeliveryProgress/>
                    </Constraint>
                  ),
                  not_accepted_by_seller: (
                    <Constraint>
                      <Notice>This order has expired, it was not accepted within the viable timeframe.</Notice>
                    </Constraint>
                  ),
                }[page.order_status] || (
                  <Constraint>
                    <Notice>Unknown item status error, please contact us. (E9101)</Notice>
                  </Constraint>
                )
              ) : page.has_offers ? (
                <Constraint offset="1.25rem">
                  <OfferList/>
                </Constraint>
              ) : (
                <Constraint offset="3rem" bottomOffset="1.5rem">
                  <CopyItem
                    from={{opacity: 0, position: 'relative'}}
                    to={{opacity: 1}}
                    title="Give this to your buyer:"
                    text={page.payment_link_url}
                    onCopy={() => {
                      analytics.track('Offer Link Copied', {
                        'Item Price': page.price,
                        'Item Name': page.title,
                        'Payment Link': page.payment_link_url,
                        'Event Initiated by': AppState.currentPage === 'CreatePaymentLinkPage' || AppState.currentPage === 'SellerLandingPage'
                          ? 'seller' : 'buyer'
                      });
                    }}
                  />
                  <HowItWorks onClick={page.showHowItWorks}>How does this work?</HowItWorks>
                </Constraint>
              )}
            </>

          )}

        </AppContent>

        <Modal showModal={page.modalIsOpen} onCancel={page.closeModal} withCloseButton>
          <EditItem afterSave={page.afterSave}/>
        </Modal>

        <Modal showModal={page.howItWorksIsOpen} onCancel={page.closeModal()} withCloseButton>
          <HowItWorksDisplay/>
        </Modal>

        <Modal showModal={modalOrderReceived} onCancel={this.toggle} withCloseButton>
          <OrderReceivedModal page={page} />
        </Modal>

        <Modal showModal={page.showCreditCardModal} onCancel={page.closeModal} withCloseButton>
          <PaymentMethodForm/>
        </Modal>

      </>
    );
  }
}
